module.exports = __webpack_public_path__ + "img/first_year_premium_filled.ade7048.svg";